<template>
	<div>
		<loading :active.sync="isLoading"></loading>
		<div v-if="formProcess > 0">
					<div class="alert alert-success" v-if="formProcess == 200">
						{{ t.form.success }}
					</div>
					<div class="alert alert-danger" v-if="formProcess == 401">
						{{ t.error.access_denied_content }}
					</div>
					<div class="alert alert-danger" v-if="formProcess == 404">
						{{ t.error.notfound_content_list }}
					</div>
		</div>

		<div class=" p-0">
			<div class="head">
				<h2>{{ t.navigation.personal_informations }}</h2>
			</div>
			<div class="element-content pb-5">
				<symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
			</div>
		</div>
	</div>
</template>

<script>

    import Choices from 'choices.js'

    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'account',
        components: { symForm },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        mounted () {
            this.getUserForm();
        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
            async fetchUserGroup () {

                this.$http.get(api+'api/v1/users/groups/get/all')
                    .then(response => {

                        this.userGroup = response.body.result.groups;
                    }, response => {

                    })
            },
            async groupsCh () {
                var e = document.getElementsByClassName("choicesx");
                for (var i = 0; i < e.length; i++){
                    var name = e[i].getAttribute("name");

                    var element = e[i];

                    var example = new Choices(element, {
                        removeItemButton: true,

                    });
                }
            },
            async fetchRegions () {

                this.$http.get(api+'api/v1/regions')
                    .then(response => {

                        this.regions = response.body.result.regions;
                    }, response => {

                    })
            },
            async getUserForm (data) {


                if(!this.isLoading) {
                    this.isLoading = true;
                    this.userForm = null;
                    this.formProcess = 0;
                    if(data) {
                        //this.userForm = null;
                        this.$http.post(api+'api/v1/form/user/'+this.$route.params.id,
                            data )
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formProcess = 200;

                                this.isLoading = false;
                                //swal('', this.t.processing.success, "success")

                                setTimeout(this.resetStatus, 5000);
	                            setTimeout(this.groupsCh, 500)

                            }, response => {
                                this.userForm = response.body.result;
                                this.formProcess = 400;
                                this.isLoading = false;
                            setTimeout(this.groupsCh, 500)

                                //swal(this.t.processing.error, this.t.processing.check, "error")
                            })

                    } else {
                        this.$http.get(api+'api/v1/form/user/'+this.$route.params.id)
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formData = response.body.form_data;
                                this.isLoading = false;
                                setTimeout(this.groupsCh, 1000)

                            }, response => {
                                this.isLoading = false;
                            })
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/personalInformations.vue